import { ReactNode } from "react";
import { useAuth } from "@/lib/auth";

export function Can({ perm, children, fallback = null }: { perm: string; children: ReactNode; fallback?: ReactNode }) {
  const { hasPerm } = useAuth();
  if (!hasPerm(perm)) return <>{fallback}</>;
  return <>{children}</>;
}
